import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton, styled } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ClassNameGenerator from "@mui/utils/ClassNameGenerator";

const ModalHeader = styled("div")({
  // background: "rgb(32, 80, 130)",
  // padding: "15px",
  // color: "#fff",
  fontSize: "20px",
  fontWeight: "700",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  position: "sticky",
  top: 0,
  background: "#fff",
  zIndex: 9,
  paddingTop: "10px",
});
const ModalBody = styled("div")({
  // padding: "15px",
});
export default function UseModal(props) {
  const { button, title, width, rowData } = props;
  const [open, setOpen] = React.useState(false);
  const handleOpen = (data) => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  console.log(rowData, "rowDatadded");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width ? width : "50%",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    // overflow: "hidden",
    padding: "10px",
    paddingTop: 0,
    height: "calc(100% - 100px)",
    // overflow: "auto",
  };

  return (
    <div>
      <div onClick={handleOpen}>
        {button === "icon" ? (
          <IconButton>
            <InfoIcon />
          </IconButton>
        ) : (
          button
        )}
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ModalHeader>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {title}
            </Typography>
            <IconButton sx={{ color: "#000" }} onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </ModalHeader>
          <ModalBody>{props.children}</ModalBody>
        </Box>
      </Modal>
    </div>
  );
}
